import { Form } from 'antd'
import styled from 'styled-components'

const StyledForm = styled(Form)`
  &.label-highlight {
    .ant-form-item {
      color: #fff;
      .ant-form-item-label > label {
        color: #a1ddff;
      }
    }
  }

  .ant-form-item {
    font-size: 16px;
    color: #fff;

    .ant-form-item-label {
      text-align: left;
      > label {
        font-size: 14px;
        color: ${p => p.theme.form.labelColor} !important;
      }
    }
  }

  .ant-form-item-label > label::after {
    content: '';
  }
`

export default StyledForm
